import React, { FC } from 'react'
import CrewDetails from '../molecules/CrewDetails';

import { useLocation } from "react-router-dom";
import MainLayout from '../../Layouts/MainLayout';
//Crew-details
const CrewDetailsPage: FC = () => {
  const location = useLocation();
  const crewName = location.state?.crewName;
  return (
   <MainLayout>
      <CrewDetails  crewName={crewName} />
   </MainLayout>
  )
}
export default CrewDetailsPage;